


import atlas from '@/components/atlas.vue';
import course from '@/components/course.vue';
import news from '@/components/news.vue';
import activity from '@/components/activity.vue';
import discussion from '@/components/discussion.vue';
import authorIndex from '@/components/authorIndex.vue';


export default {
    components: { atlas, discussion, authorIndex },
    name: 'index',
    head() {

    },
    data() {
        return {
            type: 1,
            total: '',//页码总数
            page: 1,
            pageSize: 10,
            asyncSource: [],
            asyncSourceAll: {},
            theEnd: true,//是否分页底部了
            disabled: false,//开启loding
            noSearchResults: false,//无搜索结果
            searchHistoryArr: [],//搜索历史
            firstLoad: true,
        };
    },

    mounted() {
        this.searchKeyword(this.type)
        this.searchHistory()

    },
    watch: {
        type(newValue, oldValue) {
            this.searchKeyword(newValue)
        },
        '$route.query'(newValue, oldValue) {
            this.searchKeyword(this.type)
            this.searchHistory()
        },

    },
    methods: {
        componentType(type) {

            switch (type) {
                case 2:
                case 8:
                    return 'atlas';
                case 3:
                    return 'authorIndex';
                case 4:
                    return 'course';
                case 5:
                    return 'news';
                case 6:
                    return 'activity';
                case 7:
                case 9:
                    return 'discussion';
                default:
                    return '';
            }
        },
        searchKeyword(type, add) {
            //关键字搜索
            // this.searchHistory()
            if (this.$route.query.keyword) {
                this.$store.state.searchKeyword = this.$route.query.keyword
            }
            add == 'add' ? "" : (this.asyncSource = [], this.page = 1)

            switch (type) {
                case 1:
                    this.searchAll()
                    break;
                case 2:
                    this.searchAtlas()
                    break;
                case 3:
                    this.searchAuthor()
                    break;
                case 4:
                    this.searchCourse()
                    break;
                case 5:
                    this.searchNews()
                    break;
                case 6:
                    this.searchEvent()
                    break;
                case 7:
                    this.searchDiscussion()
                    break;
                case 8:
                    this.searchTagWorksSearch()
                    break;
                case 9:
                    this.searchTagPostsSearch()
                    break;

                default:
            }
        },
        // async searchHistory() {
        //     //搜索历史
        //     let res = await this.$global.searchSearch_select()
        //     res.code == 200 ? this.searchHistoryArr = res.data : ''
        // },
        async searchHistory() {
            localStorage.getItem('recentSearch') ? this.searchHistoryArr = JSON.parse(localStorage.getItem('recentSearch')) : []
        },
        async searchAll() {
            //查询全部
            this.disabled = true
            let res = await this.$global.searchAll({ "page_count": 5, "keyword": this.$store.state.searchKeyword, "page": this.page })
            console.log(res)
            // res.data.total == 0 ? this.noSearchResults = true : this.noSearchResults = false
            res.data.activityList.data.length == 0 && res.data.articleList.data.length == 0 && res.data.postsList.data.length == 0 && res.data.userList.data.length == 0 && res.data.video_list.data.length == 0 && res.data.worksList.data.length == 0 ? this.noSearchResults = true : this.noSearchResults = false
            this.asyncSourceAll = res.data
            this.firstLoad = this.disabled = false

        },
        async searchAtlas() {
            //作品查询
            this.disabled = true
            let res = await this.$global.searchGallery({ "page_count": this.pageSize, "keyword": this.$store.state.searchKeyword, "page": this.page })
            console.log(res)
            res.data.worksList.last_page == this.page ? this.theEnd = false : (this.theEnd = true, this.page += 1)//是否是最后一页
            res.data.worksList.data.length == 0 ? this.noSearchResults = true : this.noSearchResults = false//判断有无搜索结果
            this.asyncSource = [...this.asyncSource, ...res.data.worksList.data]
            this.asyncSource.forEach(item => { item.type = 2 })
            this.firstLoad = this.disabled = false
        },
        async searchCourse() {
            //课程查询
            this.disabled = true
            let res = await this.$global.searchCourse({ "page_count": this.pageSize, "keyword": this.$store.state.searchKeyword, "page": this.page })
            console.log(res)
            res.data.video_list.last_page == this.page ? this.theEnd = false : (this.theEnd = true, this.page += 1)
            res.data.video_list.data.length == 0 ? this.noSearchResults = true : this.noSearchResults = false//判断有无搜索结果
            this.asyncSource = [...this.asyncSource, ...res.data.video_list.data]
            this.asyncSource.forEach(item => { item.type = 4 })
            this.firstLoad = this.disabled = false
        },
        async searchAuthor() {
            //用户查询
            this.disabled = true
            let res = await this.$global.searchAuthor({ "page_count": this.pageSize, "keyword": this.$store.state.searchKeyword, "page": this.page })
            console.log(res)
            res.data.userList.last_page == this.page ? this.theEnd = false : (this.theEnd = true, this.page += 1)
            res.data.userList.data.length == 0 ? this.noSearchResults = true : this.noSearchResults = false//判断有无搜索结果
            this.asyncSource = [...this.asyncSource, ...res.data.userList.data]
            this.asyncSource.forEach(item => { item.type = 3 })
            this.firstLoad = this.disabled = false
        },
        async searchNews() {
            //资讯查询
            this.disabled = true
            let res = await this.$global.searchNews({ "page_count": this.pageSize, "keyword": this.$store.state.searchKeyword, "page": this.page })
            console.log(res)
            res.data.articleList.last_page == this.page ? this.theEnd = false : (this.theEnd = true, this.page += 1)
            res.data.articleList.data.length == 0 ? this.noSearchResults = true : this.noSearchResults = false//判断有无搜索结果
            this.asyncSource = [...this.asyncSource, ...res.data.articleList.data]
            this.asyncSource.forEach(item => { item.type = 5 })
            this.firstLoad = this.disabled = false
        },
        async searchEvent() {
            //活动查询
            this.disabled = true
            let res = await this.$global.searchEvent({ "page_count": this.pageSize, "keyword": this.$store.state.searchKeyword, "page": this.page })
            console.log(res)
            res.data.activityList.last_page == this.page ? this.theEnd = false : (this.theEnd = true, this.page += 1)
            res.data.activityList.data.length == 0 ? this.noSearchResults = true : this.noSearchResults = false//判断有无搜索结果
            this.asyncSource = [...this.asyncSource, ...res.data.activityList.data]
            this.asyncSource.forEach(item => { item.type = 6 })
            this.firstLoad = this.disabled = false
        },
        async searchDiscussion() {
            //帖子查询
            this.disabled = true
            let res = await this.$global.searchDiscussion({ "page_count": this.pageSize, "keyword": this.$store.state.searchKeyword, "page": this.page })
            console.log(res)
            res.data.postsList.last_page == this.page ? this.theEnd = false : (this.theEnd = true, this.page += 1)
            res.data.postsList.data.length == 0 ? this.noSearchResults = true : this.noSearchResults = false//判断有无搜索结果
            this.asyncSource = [...this.asyncSource, ...res.data.postsList.data]
            this.asyncSource.forEach(item => { item.type = 7 })
            this.firstLoad = this.disabled = false
        },
        async searchTagWorksSearch() {
            //作品标签查询
            this.disabled = true
            let res = await this.$global.searchTagWorksSearch({ "page_count": this.pageSize, "tag_name": this.$store.state.searchKeyword, "page": this.page })
            console.log(res)
            res.data.workslist.last_page == this.page ? this.theEnd = false : (this.theEnd = true, this.page += 1)
            res.data.workslist.data.length == 0 ? this.noSearchResults = true : this.noSearchResults = false//判断有无搜索结果
            this.asyncSource = [...this.asyncSource, ...res.data.workslist.data]
            this.asyncSource.forEach(item => { item.type = 8 })
            this.firstLoad = this.disabled = false
        },
        async searchTagPostsSearch() {
            //帖子标签查询
            this.disabled = true
            let res = await this.$global.searchTagPostsSearch({ "page_count": this.pageSize, "tag_name": this.$store.state.searchKeyword, "page": this.page })
            console.log(res)
            res.data.postslist.last_page == this.page ? this.theEnd = false : (this.theEnd = true, this.page += 1)
            res.data.postslist.data.length == 0 ? this.noSearchResults = true : this.noSearchResults = false//判断有无搜索结果
            this.asyncSource = [...this.asyncSource, ...res.data.postslist.data]
            this.asyncSource.forEach(item => { item.type = 9 })
            this.firstLoad = this.disabled = false
        },
        jumpSearch() {
            //路由跳转
            let recentSearch = []
            if (localStorage.getItem('recentSearch')) {
                recentSearch = JSON.parse(localStorage.getItem('recentSearch'))
                recentSearch.length >= 10 ? (recentSearch.shift(), recentSearch.push(this.$store.state.searchKeyword)) : recentSearch.push(this.$store.state.searchKeyword)
            }
            else {
                if(this.$store.state.searchKeyword == ''){

                }else{
                    recentSearch.push(this.$store.state.searchKeyword)
                }

            }
            localStorage.setItem('recentSearch', JSON.stringify(recentSearch))
            this.$router.push({ path: '/inquire', query: { keyword: this.$store.state.searchKeyword } })

        },
        resetKeyword() {
            //重置路由参数
            this.$router.push({ path: '/inquire' })
        },
        async searchSearch_del() {
            //清空搜索记录
            // let res = await this.$global.searchSearch_del()
            // res.code == 200 ? this.searchHistory() : this.$message.error('unknown mistake');
            localStorage.removeItem('recentSearch')
            this.searchHistoryArr = []

        }


    }

}
